module.exports = __webpack_public_path__ + "static/img/img (13).07ac6a00.jpg";